import styled from 'styled-components';
import CloudinaryImage from 'components/CloudinaryImage';
import { cloudinaryUrl } from 'services/cloudinary';
import Typography, { TypeVariant } from 'shared/Typography';
import { ReactNode } from 'react';

export const WrapSectionThree = styled.div<{ bgImage: string }>`
  display: flex;
  margin-top: -30px;
  margin-left: 120px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    margin-left: 25px;
    margin-bottom: 80px;
    margin-top: -120px;
    max-width: 370px;
  } ;
`;

export const SectionThreeCol = styled.h3`
  display: flex;
  flex-direction: column;
  max-width: 475px;
  margin-right: 79px;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 105px;
  padding-top: 140px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    margin-top: 105px;
    margin-right: 0px;
    width: 100%;
    padding-bottom: 100px;
  } ;
`;

interface Props {
  children: ReactNode | ReactNode[];
}

export const SectionThreeTitle = ({ children }: Props) => (
  <Typography
    variant={TypeVariant.subtitle01}
    as="p"
    color="var(--color-white)"
  >
    {children}
  </Typography>
);

export const SectionThreeSubTitle = ({ children }: Props) => (
  <Typography
    variant={TypeVariant.bodyLarge01}
    as="p"
    color="var(--color-gray-500)"
  >
    {children}
  </Typography>
);

export const SectionThreeDesc = ({ children }: Props) => (
  <Typography
    variant={TypeVariant.bodyLarge01}
    tablet={TypeVariant.body01}
    as="p"
    color="var(--color-white)"
  >
    {children}
  </Typography>
);

export const SectionThreeSubTitleWrap = styled.div`
  margin-top: 5px;
  margin-bottom: 10px;
`;

export const SectionThreeDescWrap = styled.div`
  @media ${(p) => p.theme.queries.tabletAndDown} {
    padding-right: 20px;
  } ;
`;

export const ImageWrapThree = styled.div`
  @media ${(p) => p.theme.queries.tabletAndDown} {
    display: none;
  } ;
`;

export const Container = styled.div<{ bgImage: string }>`
  display: flex;
  justify-content: center;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    background-image: ${({ bgImage }) => `url("${bgImage}")`};
    width: 100%;
    background-size: contain;
    background-position: 320px -8px;
    background-repeat: no-repeat;
  }

  @media ${(p) => p.theme.queries.phoneAndDown} {
    background-position: 120px -8px;
  } ;
`;

const bgImage = cloudinaryUrl(
  'Group_3006__2_-removebg_1_maaouy',
  'auto',
  false,
);

const SectionThree = () => (
  <Container bgImage={bgImage}>
    <div
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <WrapSectionThree bgImage={bgImage}>
        <SectionThreeCol>
          <SectionThreeTitle>Analytics</SectionThreeTitle>
          <SectionThreeSubTitleWrap>
            <SectionThreeSubTitle>See your community grow</SectionThreeSubTitle>
          </SectionThreeSubTitleWrap>
          <SectionThreeDescWrap>
            <SectionThreeDesc>
              Get access to your members’ data and our software integrations so
              you know who is supporting you
            </SectionThreeDesc>
          </SectionThreeDescWrap>

          <div style={{ marginTop: 80 }}>
            <SectionThreeTitle>Features</SectionThreeTitle>
          </div>
          <SectionThreeSubTitleWrap>
            <SectionThreeSubTitle>
              Schedule content releases
            </SectionThreeSubTitle>
          </SectionThreeSubTitleWrap>

          <SectionThreeDescWrap>
            <SectionThreeDesc>
              Record your content in advance and schedule it to be released over
              time. Need a vacation? No problem
            </SectionThreeDesc>
          </SectionThreeDescWrap>

          <div style={{ marginTop: 80 }}>
            <SectionThreeTitle>Convert Audience</SectionThreeTitle>
          </div>
          <SectionThreeSubTitleWrap>
            <SectionThreeSubTitle>
              Solin guidance and marketing
            </SectionThreeSubTitle>
          </SectionThreeSubTitleWrap>

          <SectionThreeDescWrap>
            <SectionThreeDesc>
              Leverage Solin’s strategy team and marketing playbook to optimally
              launch and grow your audience over time
            </SectionThreeDesc>
          </SectionThreeDescWrap>
        </SectionThreeCol>
        <ImageWrapThree>
          <CloudinaryImage
            publicId="Group_3006__2_-removebg_1_maaouy"
            alt={'become creator main image'}
            width={480}
            height={980}
            quality={'auto:best'}
            fetchFormat={'auto'}
            crop={'scale'}
          />
        </ImageWrapThree>
      </WrapSectionThree>
    </div>
  </Container>
);

export default SectionThree;
